import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const pendingOrderFieldsAdapter = getAdapter({ idFieldName: 'name' });

const pendingOrderFieldsSlice = createSlice({
  name: 'pendingOrderFields',
  initialState: pendingOrderFieldsAdapter.getInitialState(),
  reducers: {
    setPendingOrderFields: (state, { payload: { pendingOrderFields } }) => {
      pendingOrderFieldsAdapter.setAll(state, pendingOrderFields);
    },
  },
});

const selectors = pendingOrderFieldsAdapter.getSelectors(({ pendingOrderFields }) => pendingOrderFields);

export const getPendingOrderFields = (state) => selectors.selectAll(state);

export const {
  setPendingOrderFields,
} = pendingOrderFieldsSlice.actions;

export default pendingOrderFieldsSlice.reducer;